<!-- LottieAnimation.vue -->
<template>
  <div ref="lottieContainer" class="lottie-container"></div>
</template>

<script>
import lottie from 'lottie-web';

export default {
  name: 'LottieAnimation',
  props: {
    // 动画数据（JSON）
    animationData: {
      type: Object,
      required: true
    },
    // 自动播放
    autoplay: {
      type: Boolean,
      default: true
    },
    // 循环播放
    loop: {
      type: Boolean,
      default: true
    },
    // 播放方向
    direction: {
      type: Number,
      default: 1
    },
    // 动画速度
    speed: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      anim: null
    };
  },
  mounted() {
    this.initLottie();
  },
  methods: {
    initLottie() {
      this.anim = lottie.loadAnimation({
        container: this.$refs.lottieContainer, // 容器
        renderer: 'svg', // 渲染类型: 'svg' | 'canvas' | 'html'
        loop: this.loop,
        autoplay: this.autoplay,
        animationData: this.animationData,
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice'
        }
      });

      this.anim.setSpeed(this.speed);
      this.anim.setDirection(this.direction);
    }
  },
  beforeDestroy() {
    if (this.anim) {
      this.anim.destroy(); // 销毁动画，防止内存泄漏
    }
  }
};
</script>

<style scoped>
.lottie-container {
  width: 100%;
  height: 100%;
}
</style>